import Async from "../components/Async";

import { BarChart, EventNote } from "@material-ui/icons";

const AuthGuard = Async(() => import("./auth.guard"));

const Agenda = Async(() => import('../pages/crm/crm.agenda'));
const OpportunityDetails = Async(() => import('../pages/crm/crm.opportunity.details'));
const Opportunities = Async(() => import('../pages/crm/crm.opportunities'));
const Analytics = Async(() => import('../pages/crm/crm.analytics'));

const routes = {
    crm: {
        id: 'Gestto',
        path: '/crm',
        icon: <EventNote />,
        component: null,
        guard: AuthGuard,
        isFlat: true,
        roles: ['seller', 'sales-manager'],
        children: [
            {
                id: 'crmAnalytics',
                name: 'Analytics',
                path: '/crm/analytics',
                icon: <BarChart />,
                component: Analytics,
                guard: AuthGuard,
                roles: ['sales-manager'],
            },
            {
                id: 'crmAgenda',
                name: 'Agenda do dia',
                path: '/crm/agenda',
                component: Agenda,
                guard: AuthGuard,
                roles: ['seller'],
            }
        ]
    },
    opportunityDetails: {
        id: 'opportunityDetails',
        path: '/crm/opportunity/:id?',
        component: OpportunityDetails,
        guard: AuthGuard,
        roles: ['seller', 'sales-manager'],
    },
    opportunities: {
        id: 'opportunities',
        path: '/crm/opportunities',
        component: Opportunities,
        guard: AuthGuard,
        roles: ['seller'],
    },
}

const pages = Object.values(routes);

export default {
    routes,
    pages
}